export default __webpack_public_path__ + "static/media/Manuscripts4.b8256c86.png";